'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/new-business/stage4/components/cover-panel.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _arrayToIso = require('@marmalade/date/lib/array-to-iso');
var _arrayToIso2 = _interopRequireDefault(_arrayToIso);
var _coverStartDate = require('@marmalade/form/lib/questions/cover-start-date');
var _coverStartDate2 = _interopRequireDefault(_coverStartDate);
var _fieldInfo = require('@marmalade/form/lib/selectors/field-info');
var _panel = require('@marmalade/panel');
var _glamorous = require('glamorous');
var _pick = require('lodash/pick');
var _pick2 = _interopRequireDefault(_pick);
var _propTypes = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _reduxWindow = require('redux-window');
var _propTypes2 = require('../../../prop-types');
var _quote = require('../../../quote');
var _stage = require('../../../validation/new-business/stage4');
var _stage2 = _interopRequireDefault(_stage);
var _constants = require('../../constants');
var _quoteOptionsToProps = require('../../selectors/quote-options-to-props');
var _quoteOptionsToProps2 = _interopRequireDefault(_quoteOptionsToProps);
var _chooseCoverRadio = require('./choose-cover-radio');
var _chooseCoverRadio2 = _interopRequireDefault(_chooseCoverRadio);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var CoverPanel = function (_Component) {
  _inherits(CoverPanel, _Component);
  function CoverPanel() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, CoverPanel);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CoverPanel.__proto__ || Object.getPrototypeOf(CoverPanel)).call.apply(_ref, [this].concat(args))), _this), _this.updateQuotes = function () {
      if (_this.props.existingStartDate !== (0, _arrayToIso2.default)(_this.props.coverStartDate) && !(0, _stage2.default)({
        licenceStartDate: _this.props.licenceStartDate,
        dateOfBirth: _this.props.dateOfBirth
      }).coverStartDate(_this.props.coverStartDate).length) {
        _this.props.fetchQuotes(_this.props.theme, true);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(CoverPanel, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var Element = props.lgScreen ? _panel.PanelAside : _panel.Panel;
      return _react2.default.createElement(Element, {
        className: 'cover-panel',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 65
        },
        __self: this
      }, _react2.default.createElement('h2', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 66
        },
        __self: this
      }, 'Cover details'), _react2.default.createElement('p', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 67
        },
        __self: this
      }, 'Your cover options are based on the postcode: ', _react2.default.createElement('strong', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 68
        },
        __self: this
      }, props.postcode), ' and age:', ' ', _react2.default.createElement('strong', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 69
        },
        __self: this
      }, props.age), _react2.default.createElement('br', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 70
        },
        __self: this
      }), _react2.default.createElement('strong', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 71
        },
        __self: this
      }, 'Quote reference number: ', props.policyId)), _react2.default.createElement(_chooseCoverRadio2.default, {
        name: 'cover',
        options: [{
          cover: 30,
          premium: props.quote30
        }, {
          cover: 60,
          premium: props.quote60
        }, {
          cover: 90,
          premium: props.quote90
        }, {
          cover: 120,
          premium: props.quote120
        }, {
          cover: 180,
          premium: props.quote180
        }, {
          cover: 240,
          premium: props.quote240
        }],
        updating: this.props.updating,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 73
        },
        __self: this
      }), _react2.default.createElement(_coverStartDate2.default, {
        helpText: 'Cover will commence from the time your payment is confirmed, or from midnight on a future date.',
        onBlur: this.updateQuotes,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 85
        },
        __self: this
      }), _react2.default.createElement('small', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 89
        },
        __self: this
      }, 'Prices include your premium, Insurance Premium Tax at 12%, and a non-refundable administration fee of \xA3', props.adminFee));
    }
  }]);
  return CoverPanel;
}(_react.Component);
CoverPanel.propTypes = {
  // STP
  age: _propTypes.string.isRequired,
  postcode: _propTypes.string.isRequired,
  coverStartDate: _propTypes.array.isRequired,
  existingStartDate: _propTypes.string.isRequired,
  quote30: _propTypes2.quoteModel,
  quote60: _propTypes2.quoteModel,
  quote90: _propTypes2.quoteModel,
  quote120: _propTypes2.quoteModel,
  quote180: _propTypes2.quoteModel,
  quote240: _propTypes2.quoteModel,
  lgScreen: _propTypes.bool.isRequired,
  updating: _propTypes.bool.isRequired,
  licenceStartDate: _propTypes.array.isRequired,
  dateOfBirth: _propTypes.array.isRequired,
  // DTP
  fetchQuotes: _propTypes.func.isRequired,
  theme: _propTypes.object
};
CoverPanel.defaultProps = {
  quote30: '',
  quote60: '',
  quote90: '',
  quote120: '',
  quote180: '',
  quote240: ''
};
function getQuoteObject(quote) {
  return quote ? (0, _pick2.default)(quote, 'premium', 'daily') : {};
}
exports.default = (0, _reactRedux.connect)(function (state) {
  var quotes = _quote.selectors.getQuotes(state);
  var selectedCover = (0, _fieldInfo.getValue)(state, _constants.stages[3].formId, 'cover');
  var selectedQuote = quotes.find(function (quote) {
    return String(quote.cover) === selectedCover;
  });
  var selectedOrFirstQuote = selectedQuote || quotes[0];
  return Object.assign({
    lgScreen: (0, _reduxWindow.getWidth)(state) >= 992,
    updating: _quote.selectors.getQuoteInfo(state).fetching,
    quote30: getQuoteObject(quotes.find(function (quote) {
      return String(quote.cover) === '30';
    })),
    quote60: getQuoteObject(quotes.find(function (quote) {
      return String(quote.cover) === '60';
    })),
    quote90: getQuoteObject(quotes.find(function (quote) {
      return String(quote.cover) === '90';
    })),
    quote120: getQuoteObject(quotes.find(function (quote) {
      return String(quote.cover) === '120';
    })),
    quote180: getQuoteObject(quotes.find(function (quote) {
      return String(quote.cover) === '180';
    })),
    quote240: getQuoteObject(quotes.find(function (quote) {
      return String(quote.cover) === '240';
    }))
  }, (0, _quoteOptionsToProps2.default)(state), {
    existingStartDate: _quote.selectors.getQuoteOptions(state).coverStartDate,
    licenceStartDate: (0, _fieldInfo.getValue)(state, _constants.stages[1].formId, 'licenceStartDate'),
    coverStartDate: (0, _fieldInfo.getValue)(state, _constants.stages[3].formId, 'coverStartDate'),
    dateOfBirth: (0, _fieldInfo.getValue)(state, _constants.stages[1].formId, 'dateOfBirth'),
    policyId: _quote.selectors.getQuoteInfo(state).policy.id,
    adminFee: selectedOrFirstQuote ? selectedOrFirstQuote.adminFee : '--.--'
  });
}, {
  fetchQuotes: _quote.actions.fetchFullQuote
})((0, _glamorous.withTheme)(CoverPanel));